import { useGenericForm } from '@/hooks/use-generic-form';
import { signUpSchema } from '@/validation/sign-up.schema';
import { AxiosError } from 'axios';
import { z } from 'zod';
import { useSignUp } from '@/api/auth/auth.hooks.ts';
import { TokenResponse } from '@/api/auth/auth.types.ts';

type SignUpFormData = z.infer<typeof signUpSchema>;

export const useSignUpForm = ({
  onSuccess,
  onError,
}: {
  onSuccess?: (response: TokenResponse) => void;
  onError?: (error: AxiosError<any>) => void;
}) => {
  const signUpMutation = useSignUp();

  return useGenericForm<SignUpFormData, TokenResponse>({
    schema: signUpSchema,
    mutation: signUpMutation,
    onSuccess,
    onError,
  });
};
